import { render, staticRenderFns } from "./newInfoCheck.vue?vue&type=template&id=4a162958&scoped=true&"
import script from "./newInfoCheck.vue?vue&type=script&lang=js&"
export * from "./newInfoCheck.vue?vue&type=script&lang=js&"
import style0 from "./newInfoCheck.vue?vue&type=style&index=0&id=4a162958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a162958",
  null
  
)

export default component.exports